import _defineProperty from "/workspace/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workspace/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/workspace/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/workspace/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/workspace/node_modules/@babel/runtime/helpers/esm/createClass.js";
var _excluded = ["class"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import SequentialIDGenerator from "../sequential-id-generator";
import { Cache, MultiCache } from "../cache";
import injectStylePrefixed from "../inject-style-prefixed";
import { styleBlockToRule, atomicSelector, keyframesBlockToRule, declarationsToBlock, keyframesToBlock, fontFaceBlockToRule } from "../css";

var StyletronServer = /*#__PURE__*/function () {
  function StyletronServer() {
    var _this = this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, StyletronServer);

    this.styleRules = {
      "": ""
    };
    this.styleCache = new MultiCache(new SequentialIDGenerator(opts.prefix), function (media) {
      _this.styleRules[media] = "";
    }, function (cache, id, value) {
      var pseudo = value.pseudo,
          block = value.block;
      _this.styleRules[cache.key] += styleBlockToRule(atomicSelector(id, pseudo), block);
    });
    this.fontFaceRules = "";
    this.fontFaceCache = new Cache(new SequentialIDGenerator(opts.prefix), function (cache, id, value) {
      _this.fontFaceRules += fontFaceBlockToRule(id, declarationsToBlock(value));
    });
    this.keyframesRules = "";
    this.keyframesCache = new Cache(new SequentialIDGenerator(opts.prefix), function (cache, id, value) {
      _this.keyframesRules += keyframesBlockToRule(id, keyframesToBlock(value));
    });
  }

  _createClass(StyletronServer, [{
    key: "renderStyle",
    value: function renderStyle(style) {
      return injectStylePrefixed(this.styleCache, style, "", "");
    }
  }, {
    key: "renderFontFace",
    value: function renderFontFace(fontFace) {
      var key = JSON.stringify(fontFace);
      return this.fontFaceCache.addValue(key, fontFace);
    }
  }, {
    key: "renderKeyframes",
    value: function renderKeyframes(keyframes) {
      var key = JSON.stringify(keyframes);
      return this.keyframesCache.addValue(key, keyframes);
    }
  }, {
    key: "getStylesheets",
    value: function getStylesheets() {
      return [].concat(_toConsumableArray(this.keyframesRules.length ? [{
        css: this.keyframesRules,
        attrs: {
          "data-hydrate": "keyframes"
        }
      }] : []), _toConsumableArray(this.fontFaceRules.length ? [{
        css: this.fontFaceRules,
        attrs: {
          "data-hydrate": "font-face"
        }
      }] : []), _toConsumableArray(sheetify(this.styleRules, this.styleCache.getSortedCacheKeys())));
    }
  }, {
    key: "getStylesheetsHtml",
    value: function getStylesheetsHtml() {
      var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "_styletron_hydrate_";
      return generateHtmlString(this.getStylesheets(), className);
    }
  }, {
    key: "getCss",
    value: function getCss() {
      return this.keyframesRules + this.fontFaceRules + stringify(this.styleRules, this.styleCache.getSortedCacheKeys());
    }
  }]);

  return StyletronServer;
}();

export function generateHtmlString(sheets, className) {
  var html = "";

  for (var i = 0; i < sheets.length; i++) {
    var sheet = sheets[i];

    var _sheet$attrs = sheet.attrs,
        originalClassName = _sheet$attrs.class,
        rest = _objectWithoutProperties(_sheet$attrs, _excluded);

    var attrs = _objectSpread({
      class: originalClassName ? "".concat(className, " ").concat(originalClassName) : className
    }, rest);

    html += "<style".concat(attrsToString(attrs), ">").concat(sheet.css, "</style>");
  }

  return html;
}

function attrsToString(attrs) {
  var result = "";

  for (var attr in attrs) {
    var value = attrs[attr];

    if (value === true) {
      result += " " + attr;
    } else if (value !== false) {
      result += " ".concat(attr, "=\"").concat(value, "\"");
    }
  }

  return result;
}

function stringify(styleRules, sortedCacheKeys) {
  var result = "";
  sortedCacheKeys.forEach(function (cacheKey) {
    var rules = styleRules[cacheKey];

    if (cacheKey !== "") {
      result += "@media ".concat(cacheKey, "{").concat(rules, "}");
    } else {
      result += rules;
    }
  });
  return result;
}

function sheetify(styleRules, sortedCacheKeys) {
  if (sortedCacheKeys.length === 0) {
    return [{
      css: "",
      attrs: {}
    }];
  }

  var sheets = [];
  sortedCacheKeys.forEach(function (cacheKey) {
    // omit media (cacheKey) attribute if empty
    var attrs = cacheKey === "" ? {} : {
      media: cacheKey
    };
    sheets.push({
      css: styleRules[cacheKey],
      attrs: attrs
    });
  });
  return sheets;
}

export default StyletronServer;